import "core-js/modules/es.json.parse.js";
export const inventoryInwardSubMenu = [{
  path: '/inventory-inwards/list',
  component: () => import('@/views/inventory-inwards/list.vue'),
  name: 'schemeManagement.inventoryInward.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Unit Manager', 'Read Only', 'Regional Manager', 'Zonal Manager'],
    title: 'schemeManagement.inventoryInward.title',
    noCache: true,
    icon: 'auction'
  }
}, {
  path: '/inventory-inwards/edit/:id(\\d+)',
  component: () => import('@/views/inventory-inwards/manage.vue'),
  name: 'schemeManagement.inventoryInward.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'schemeManagement.inventoryInward.edit',
    noCache: true,
    activeMenu: '/inventory-inwards/list',
    hidden: true
  }
}, {
  path: '/inventory-inwards/add',
  component: () => import('@/views/inventory-inwards/manage.vue'),
  name: 'schemeManagement.inventoryInward.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.inventoryInward.add',
    noCache: true,
    activeMenu: '/inventory-inwards/list',
    hidden: true
  }
}, {
  path: '/inventory-inwards/stock',
  component: () => import('@/views/inventory-inwards/stock.vue'),
  name: 'schemeManagement.inventoryInward.stock',
  props: route => ({
    query: JSON.parse(route.query.query)
  }),
  meta: {
    title: 'schemeManagement.inventoryInward.stock',
    noCache: true,
    activeMenu: '/inventory-inwards/list',
    hidden: true
  }
}];